// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Account-__styles__wrapper--2Aagm","header":"src-components-Account-__styles__header--lvR4A","rule":"src-components-Account-__styles__rule--3X5Vz","main":"src-components-Account-__styles__main--2iISR","footer":"src-components-Account-__styles__footer--5tHUL","textBox":"src-components-Account-__styles__textBox--2wuSb","show":"src-components-Account-__styles__show--2BvF-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Account/styles.css
// module id = 770
// module chunks = 0